import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import { PhotoIcon as Photo } from '@zola/zola-ui/src/components/SvgIconsV3/Photo';
import { CameraPlusIcon as CameraPlus } from '@zola/zola-ui/src/components/SvgIconsV3/CameraPlus';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { keyframes } from '@emotion/react';
import { COLORS3, ZINDEX } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';

export const PreviewIcon = styled.img`
  width: 38px;
  height: 38px;
  margin-right: 18px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid white;
  padding: 1px;
`;

export const CameraPlusIcon = styled(CameraPlus)`
  margin-right: ${SPACING.XS};
`;

export const PhotoIcon = styled(Photo)`
  margin-right: ${SPACING.XS};
`;
const bounce = keyframes`
0% {
  transform: scale(1)
}
20% {
  transform: scale(1)
}
22% {
  transform: scale(1.15)
}
24%{
  transform: scale(1);
}
26% {
  transform: scale(1.05);
}

28%{ 
  transform: scale(1)
}

32%{ 
  transform: scale(1)
}

34% {
  transform: scale(1.15)
}
36% {
  transform: scale(1);
}
38% {
  transform: scale(1.05);
}
40%{ 
  transform: scale(1)
}

100% {
  transform: scale(1)
}`;

export const StyledButton = styled(ButtonV3)<{ isMakePhotoPreviewMoreProminent?: boolean }>`
  white-space: nowrap;

  ${(props) =>
    props.isMakePhotoPreviewMoreProminent &&
    `
    position: relative;
    width: 207px;
    z-index: ${ZINDEX.middle};
  `}
`;

export const ButtonAnimation = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: ${COLORS3.FOREST_100};
  animation: ${bounce} 10s infinite ease-out;
  border-radius: 100px;
  z-index: 0;

  ${MEDIA_QUERY_V2.MOBILE} {
    animation-iteration-count: 1;
  }
`;

export const ButtonWrapper = styled.div<{ isMakePhotoPreviewMoreProminent: boolean }>`
  ${(props) =>
    props.isMakePhotoPreviewMoreProminent &&
    `
    position: relative; 
  `}
`;
